import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiCallQueueingServiceBase } from "./api-call-queueing-service-base";
import { AppSettingsService } from "./appsettings";
import { HttpResponse } from "@angular/common/http";

@Injectable()
export class ShowTimeBalanceMailTeaserService extends ApiCallQueueingServiceBase<HttpResponse<boolean>> {

    constructor(appSettingsService: AppSettingsService) {
        super(() => appSettingsService.getAppSetting("ShowTimeBalanceMailTeaser"));
    }

    public showTimeBalanceMailTeaser(): Observable<boolean> {
        return this.retrieveOrWait().pipe(map(res => res?.body));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/show-time-balance-mail-teaser.service.ts